import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  header: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    minHeight: "115px"
  },
  headerContent: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    alignItems: "center"
  },
  titleContainer: {
    display: "flex",
    flex: 1
  },
  icon: {
    color: theme.palette.primary.contrastText,
    marginRight: theme.spacing(2)
  },
  pageTitle: {
    fontSize: "2rem",
    color: theme.palette.primary.contrastText
  }
}));
